export { GatedHome } from './GatedHome';
